import { History24Regular } from "@fluentui/react-icons";
import { Button, makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import styles from "./HistoryButton.module.css";

const useOverrides = makeStyles({
    button: {
        background: "rgba(0, 146, 212, 1);",
        color: "rgba(255, 255, 255, 1)",
        borderRadius: "0.5rem",
        paddingBlock: "0.5rem",
        paddingInline: "0.75rem",
        gap: "0.375em",
        "&:hover": { background: "rgba(76, 179, 225, 1)", color: "rgba(255, 255, 255, 1)" },
        "&:active": { background: "rgba(76, 179, 225, 1)", color: "rgba(255, 255, 255, 1)" },
        "&:hover:active": { background: "rgba(76, 179, 225, 1)", color: "rgba(255, 255, 255, 1)" }
    }
});

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const HistoryButton = ({ className, disabled, onClick }: Props) => {
    const { t } = useTranslation();
    const overrides = useOverrides();

    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Button icon={<History24Regular />} disabled={disabled} onClick={onClick} className={overrides.button}>
                {t("history.openChatHistory")}
            </Button>
        </div>
    );
};
